import $ from 'jquery'
import { Core } from './core'

const STICKY_CLOSED_STORAGE_KEY = 'cegid.chatbot.stickyClosed'
// Token signé par le serveur ("<conversationId>.<signature>") : seul identifiant de conversation accepté par le proxy.
const CONVERSATION_TOKEN_STORAGE_KEY = 'cegid.chatbot.conversationToken'
const LEGACY_CONVERSATION_ID_STORAGE_KEY = 'cegid.chatbot.conversationId'
const USER_ID_STORAGE_KEY = 'cegid.chatbot.userId'
const LANGUAGE_STORAGE_KEY = 'cegid.chatbot.language'

// Part de la première section qui doit avoir défilé avant d'afficher le sticky.
const SECTION_SCROLL_THRESHOLD_DESKTOP = 0.6
const SECTION_SCROLL_THRESHOLD_MOBILE = 0.8

// Durée du fondu entre deux messages d'attente, alignée sur $ts-medium (chatbot.scss).
const THINKING_FADE_DURATION = 350

// Vitesse de frappe du placeholder (ms entre chaque lettre).
const PLACEHOLDER_TYPING_SPEED = 45

// Durée d'affichage de l'état « copié » sur le bouton copier (ms).
const COPIED_FEEDBACK_DURATION = 1500

// Délai d'affichage des suggestions de la barre flottante une fois celle-ci visible (ms).
const STICKY_PROMPTS_DELAY = 6000

// Hauteur max du textarea de la modale avant d'afficher un scroll (px).
const PROMPT_MAX_HEIGHT = 160

const DEFAULT_LABELS = {
  you: 'Vous',
  copy: 'Copier',
  copied: 'Copié',
  like: 'Réponse utile',
  dislike: 'Réponse pas utile'
}

export class Tolkai {
  constructor() {
    this.$root = $(document.documentElement)
    this.$buttonStickyBottom = $('#js-chatbot')
    this.$stickyWidget = $('.js-chatbot-sticky')
    // On scope l'input du sticky pour le distinguer des widgets inline (shortcode).
    this.$stickyInput = this.$stickyWidget.find('.js-chatbot-input')
    this.$stickyClose = $('.js-chatbot-sticky-close')
    this.$stickyExpand = $('.js-chatbot-sticky-expand')
    this.$overlay = $('.js-chatbot-overlay')
    this.$modal = $('.js-chatbot-modal')
    this.$modalInput = this.$modal.find('.js-chatbot-input')
    this.$modalClose = $('.js-chatbot-modal-close')
    this.$messages = $('.js-chatbot-messages')
    this.$loader = $('.js-chatbot-loader')
    this.$loaderLabel = this.$loader.find('.js-chatbot-loader-label')
    this.thinkingMessages = (window.chatbotConfig && window.chatbotConfig.thinkingMessages) || []
    this.thinkingTimers = []
    this.$reset = $('.js-chatbot-reset')
    // Le gate sur la première section ne s'applique que sur la home.
    this.$firstSection = $('body').hasClass('home')
      ? $('#content').children().not('script, style').first()
      : $()
    this.$footer = $('.footer').first()
    this.labels = $.extend({}, DEFAULT_LABELS, window.chatbotConfig && window.chatbotConfig.labels)
    this.isStickyClosed = this.readStickyClosedFromStorage()
    this.isFooterVisible = false
    this.isRequestPending = false
    this.removeFromStorage(LEGACY_CONVERSATION_ID_STORAGE_KEY)
    this.setConversationToken(this.readFromStorage(CONVERSATION_TOKEN_STORAGE_KEY))
    this.userId = this.readFromStorage(USER_ID_STORAGE_KEY) || this.generateId()
    this.writeToStorage(USER_ID_STORAGE_KEY, this.userId)
    this.languages = (window.chatbotConfig && window.chatbotConfig.languages) || []
    this.language = this.getInitialLanguage()

    this.$root.addClass('chatbot-ui-ready')

    this.initPlaceholderTyping()
    this.initStickyBehavior()
    this.syncConversationState()
    this.loadHistory()

    $(this.$stickyClose).on('click', this.handleStickyClose.bind(this))
    $(this.$stickyExpand).on('click', this.handleClickButtonStickyBottom.bind(this))
    $(this.$overlay).on('click', this.handleUiClose.bind(this))
    $(this.$modalClose).on('click', this.handleUiClose.bind(this))
    $(this.$reset).on('click', this.handleReset.bind(this))

    // Header dropdowns: mobile menu (burger) and language picker (desktop flag)
    $(document).on('click', '.js-chatbot-dropdown-toggle', this.handleDropdownToggle.bind(this))
    $(document).on('click', '.js-chatbot-language-toggle', this.handleLanguageListToggle.bind(this))
    $(document).on('click', '.js-chatbot-language', this.handleLanguageClick.bind(this))
    $(document).on('click', '.js-chatbot-copy-conversation', this.handleCopyConversationClick.bind(this))
    $(document).on('click', this.handleDocumentClick.bind(this))
    $(document).on('keydown', this.handleDocumentKeydown.bind(this))

    // Handle chatbot widget form submission
    $(document).on('submit', '.js-chatbot-form', this.handleFormSubmit.bind(this))

    // Enable the submit button only when there is something to send
    $(document).on('input', '.js-chatbot-input', this.handleInput.bind(this))

    // Enter sends, Shift+Enter adds a new line (modal textarea)
    $(document).on('keydown', 'textarea.js-chatbot-input', this.handleTextareaKeydown.bind(this))

    // Handle chatbot widget tag click
    $(document).on('click', '.js-chatbot-tag', this.handleTagClick.bind(this))

    // Handle chatbot quick-reply click (choice/link/custom-answer/static-content)
    $(document).on('click', '.js-chatbot-quick-reply', this.handleQuickReplyClick.bind(this))

    // Handle chatbot message actions (copy / like / dislike)
    $(document).on('click', '.js-chatbot-copy', this.handleCopyClick.bind(this))
    $(document).on('click', '.js-chatbot-feedback', this.handleFeedbackClick.bind(this))

    // Handle chatbot widget button click
    $(this.$buttonStickyBottom).on('click', this.handleClickButtonStickyBottom.bind(this))
  }

  handleReset(e) {
    e.preventDefault()
    e.currentTarget.blur()

    this.setConversationToken('')
    this.writeToStorage(CONVERSATION_TOKEN_STORAGE_KEY, '')
    this.$messages.children().not(this.$loader).remove()
    this.closeDropdowns()
    this.syncConversationState()
    this.$modalInput.trigger('focus')
  }

  handleDropdownToggle(e) {
    e.preventDefault()

    const $wrapper = $(e.currentTarget).closest('.chatbot-dropdown-wrapper')
    const isOpen = !$wrapper.hasClass('is-open')

    this.closeDropdowns()
    $wrapper.toggleClass('is-open', isOpen)
    $(e.currentTarget).attr('aria-expanded', isOpen ? 'true' : 'false')
  }

  handleLanguageListToggle(e) {
    e.preventDefault()

    const $toggle = $(e.currentTarget)
    const isOpen = $toggle.attr('aria-expanded') !== 'true'

    $toggle.attr('aria-expanded', isOpen ? 'true' : 'false')
    $toggle.next('.js-chatbot-language-list').toggleClass('is-open', isOpen)
  }

  handleDocumentClick(e) {
    if (!$(e.target).closest('.chatbot-dropdown-wrapper').length) {
      this.closeDropdowns()
    }
  }

  closeDropdowns() {
    this.$modal.find('.chatbot-dropdown-wrapper').removeClass('is-open')
    this.$modal.find('.js-chatbot-dropdown-toggle, .js-chatbot-language-toggle').attr('aria-expanded', 'false')
    this.$modal.find('.js-chatbot-language-list').removeClass('is-open')
  }

  /**
   * Tolk.ai language code: the visitor's last choice if still available,
   * otherwise the default one set in the back-office (site language if selected).
   *
   * @return {string}
   */
  getInitialLanguage() {
    const stored = this.readFromStorage(LANGUAGE_STORAGE_KEY)
    const defaultLanguage = (window.chatbotConfig && window.chatbotConfig.defaultLanguage) || 'fr'

    return this.languages.some((language) => language.code === stored) ? stored : defaultLanguage
  }

  handleLanguageClick(e) {
    e.preventDefault()

    const code = String($(e.currentTarget).data('language'))
    const language = this.languages.find((item) => item.code === code)

    if (!language) {
      return
    }

    this.language = code
    this.writeToStorage(LANGUAGE_STORAGE_KEY, code)

    this.$modal.find('.js-chatbot-language').each((index, el) => {
      $(el).attr('aria-checked', String($(el).data('language')) === code ? 'true' : 'false')
    })

    if (language.flag_url) {
      this.$modal.find('.js-chatbot-language-flag').attr('src', language.flag_url)
    }

    this.$modal.find('.js-chatbot-language-name').text(language.name)

    this.closeDropdowns()
  }

  handleCopyConversationClick(e) {
    e.preventDefault()

    const botName = this.$modal.find('.chatbot-modal-title').first().text().trim()
    const lines = []

    this.$messages.find('.chatbot-message-user, .chatbot-message-bot').each((index, el) => {
      const text = ($(el).find('.chatbot-message-bubble').get(0) || {}).innerText || ''

      if (text.trim()) {
        lines.push(`${$(el).hasClass('chatbot-message-user') ? this.labels.you : botName} : ${text.trim()}`)
      }
    })

    if (!lines.length) {
      this.closeDropdowns()
      return
    }

    const $label = $(e.currentTarget).find('span').first()
    const label = $label.text()

    this.copyToClipboard(lines.join('\n\n')).then(() => {
      $label.text(this.labels.copied)

      window.setTimeout(() => {
        $label.text(label)
        this.closeDropdowns()
      }, COPIED_FEEDBACK_DURATION)
    }).catch(() => {
      this.closeDropdowns()
    })
  }

  /**
   * Toggle the "empty conversation" state (welcome screen + compact prompt) and
   * the matching placeholder of the modal input.
   */
  syncConversationState() {
    const isEmpty = !this.$messages.children().not(this.$loader).length && !this.isRequestPending

    this.$modal.toggleClass('is-empty', isEmpty)

    this.$modalInput.each((index, el) => {
      const $input = $(el)
      const placeholder = isEmpty ? $input.data('placeholderText') : $input.data('placeholderFollowup')

      if (placeholder) {
        $input.attr({ placeholder: placeholder, 'aria-label': placeholder })
      }
    })
  }

  initStickyBehavior() {
    if (!this.$stickyWidget.length) {
      return
    }

    if (!this.$firstSection.length && !this.$footer.length) {
      this.showSticky()
      return
    }

    $(window).on('scroll resize', this.handleScroll.bind(this))
    this.handleScroll()
  }

  handleScroll() {
    this.updateFooterVisibility()
    this.syncStickyVisibility()
  }

  updateFooterVisibility() {
    if (!this.$footer.length) {
      this.isFooterVisible = false
      return
    }

    const footerTop = this.$footer.offset().top
    const viewportBottom = ($(window).scrollTop() || 0) + $(window).height()

    this.isFooterVisible = viewportBottom >= footerTop
  }

  openChatbotUi() {
    const wasOpen = this.$root.hasClass('chatbot-ui-open')

    this.$root.addClass('chatbot-ui-open')
    this.$overlay.attr('aria-hidden', 'false')
    this.$modal.attr('aria-hidden', 'false')
    this.hideSticky()

    if (!wasOpen && !Core.isBpLessThan('md')) {
      this.$modalInput.trigger('focus')
    }
  }

  closeChatbotUi() {
    this.closeDropdowns()
    this.$root.removeClass('chatbot-ui-open')
    this.$overlay.attr('aria-hidden', 'true')
    this.$modal.attr('aria-hidden', 'true')
    this.syncStickyVisibility()
  }

  handleUiClose(e) {
    e.preventDefault()
    e.currentTarget.blur()
    this.closeChatbotUi()
  }

  handleDocumentKeydown(e) {
    if (e.key !== 'Escape' || !this.$root.hasClass('chatbot-ui-open')) {
      return
    }

    // Échap ferme d'abord un menu déroulant ouvert, puis la modale.
    if (this.$modal.find('.chatbot-dropdown-wrapper.is-open').length) {
      this.closeDropdowns()
      return
    }

    this.closeChatbotUi()
  }

  handleStickyClose(e) {
    e.preventDefault()
    e.currentTarget.blur()

    this.isStickyClosed = true
    this.writeStickyClosedToStorage(true)
    this.hideSticky()
  }

  readStickyClosedFromStorage() {
    try {
      return window.localStorage.getItem(STICKY_CLOSED_STORAGE_KEY) === '1'
    } catch (err) {
      return false
    }
  }

  writeStickyClosedToStorage(isClosed) {
    try {
      window.localStorage.setItem(STICKY_CLOSED_STORAGE_KEY, isClosed ? '1' : '0')
    } catch (err) {
      // localStorage indisponible (mode privé, quota...) : ignorer silencieusement.
    }
  }

  readFromStorage(key) {
    try {
      return window.localStorage.getItem(key) || ''
    } catch (err) {
      return ''
    }
  }

  writeToStorage(key, value) {
    try {
      window.localStorage.setItem(key, value)
    } catch (err) {
      // localStorage indisponible (mode privé, quota...) : ignorer silencieusement.
    }
  }

  removeFromStorage(key) {
    try {
      window.localStorage.removeItem(key)
    } catch (err) {
      // localStorage indisponible (mode privé, quota...) : ignorer silencieusement.
    }
  }

  setConversationToken(token) {
    this.conversationToken = token
    // L'identifiant Tolk.ai brut reste utile pour le suivi (dataLayer).
    this.conversationId = token ? token.slice(0, token.lastIndexOf('.')) : ''
  }

  generateId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID()
    }

    return `user-${Date.now()}-${Math.random().toString(16).slice(2)}`
  }

  syncStickyVisibility() {
    if (!this.$stickyWidget.length) {
      return
    }

    if (this.$root.hasClass('chatbot-ui-open')) {
      this.hideSticky()
      return
    }

    if (this.isStickyClosed) {
      this.hideSticky()
      return
    }

    if (this.isFooterVisible) {
      this.hideSticky()
      return
    }

    if (!this.$firstSection.length) {
      this.showSticky()
      return
    }

    const scrollTop = $(window).scrollTop() || 0
    const sectionTop = this.$firstSection.offset().top
    const sectionHeight = this.$firstSection.outerHeight() || 0
    const threshold = Core.isBpLessThan('md')
      ? SECTION_SCROLL_THRESHOLD_MOBILE
      : SECTION_SCROLL_THRESHOLD_DESKTOP

    // On affiche le sticky une fois la part requise de la première section dépassée.
    const shouldShow = scrollTop >= sectionTop + (sectionHeight * threshold)

    if (shouldShow) {
      this.showSticky()
      return
    }

    this.hideSticky()
  }

  showSticky() {
    const wasVisible = this.$stickyWidget.hasClass('is-visible')

    this.$stickyWidget.addClass('is-visible').attr('aria-hidden', 'false')

    // On (re)joue l'effet de frappe uniquement quand le sticky passe de masqué à visible.
    if (!wasVisible) {
      this.typePlaceholder(this.$stickyInput)
      this.scheduleStickyPrompts()
    }
  }

  /**
   * Reveal the floating bar suggestions after the bar has been visible for
   * STICKY_PROMPTS_DELAY (the timer restarts if the bar is hidden meanwhile).
   */
  scheduleStickyPrompts() {
    if (!this.$stickyWidget.hasClass('has-prompts') || this.$stickyWidget.hasClass('is-prompts-visible')) {
      return
    }

    window.clearTimeout(this.stickyPromptsTimer)
    this.stickyPromptsTimer = window.setTimeout(() => {
      this.$stickyWidget.addClass('is-prompts-visible')
    }, STICKY_PROMPTS_DELAY)
  }

  initPlaceholderTyping() {
    const $inputs = $('.js-chatbot-input')

    // On mémorise puis on vide chaque placeholder pour pouvoir l'animer.
    $inputs.each((index, el) => {
      const $input = $(el)
      $input.data('placeholderText', $input.attr('placeholder') || '')
      $input.attr('placeholder', '')
    })

    // La modale n'a pas d'effet de frappe : son placeholder est affiché tel quel.
    this.$modalInput.each((index, el) => {
      $(el).attr('placeholder', $(el).data('placeholderText'))
    })

    // Les widgets inline (shortcode) s'animent dès qu'ils entrent dans le viewport,
    // donc immédiatement s'ils sont déjà visibles sans scroller. Le sticky, lui,
    // est piloté par showSticky().
    const $inlineInputs = $inputs.filter((index, el) => $(el).closest('.js-chatbot-sticky, .js-chatbot-modal').length === 0)

    if (!$inlineInputs.length) {
      return
    }

    if (typeof window.IntersectionObserver !== 'function') {
      // Repli : pas d'IntersectionObserver, on affiche directement le placeholder.
      $inlineInputs.each((index, el) => this.typePlaceholder($(el)))
      return
    }

    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return
        }

        this.typePlaceholder($(entry.target))
        observer.unobserve(entry.target)
      })
    }, { threshold: 0.5 })

    $inlineInputs.each((index, el) => observer.observe(el))
  }

  typePlaceholder($input) {
    if (!$input || !$input.length) {
      return
    }

    const text = $input.data('placeholderText') || ''

    if (!text) {
      return
    }

    window.clearTimeout($input.data('placeholderTimer'))

    let index = 0
    $input.attr('placeholder', '')

    const typeNextChar = () => {
      index += 1
      $input.attr('placeholder', text.slice(0, index))

      if (index < text.length) {
        $input.data('placeholderTimer', window.setTimeout(typeNextChar, PLACEHOLDER_TYPING_SPEED))
      }
    }

    typeNextChar()
  }

  hideSticky() {
    window.clearTimeout(this.$stickyInput.data('placeholderTimer'))
    window.clearTimeout(this.stickyPromptsTimer)
    this.$stickyWidget.removeClass('is-visible').attr('aria-hidden', 'true')
  }

  handleClickButtonStickyBottom(e) {
    e.preventDefault()

    this.isStickyClosed = false
    this.writeStickyClosedToStorage(false)

    this.openChatbotUi()
  }

  handleInput(e) {
    const $input = $(e.currentTarget)

    this.syncSubmitState($input.closest('.js-chatbot-form'))

    if ($input.is('textarea')) {
      this.resizeTextarea($input)
    }
  }

  handleTextareaKeydown(e) {
    if (e.key !== 'Enter' || e.shiftKey || e.isComposing) {
      return
    }

    e.preventDefault()
    $(e.currentTarget).closest('.js-chatbot-form').trigger('submit')
  }

  syncSubmitState($form) {
    const value = $form.find('.js-chatbot-input').val() || ''

    $form.find('.js-chatbot-submit').prop('disabled', !value.trim())
  }

  resizeTextarea($textarea) {
    const textarea = $textarea.get(0)

    if (!textarea) {
      return
    }

    textarea.style.height = 'auto'
    textarea.style.height = `${Math.min(textarea.scrollHeight, PROMPT_MAX_HEIGHT)}px`
  }

  handleFormSubmit(e) {
    e.preventDefault()

    const $form = $(e.currentTarget)
    const $input = $form.find('.js-chatbot-input')
    const message = ($input.val() || '').trim()

    if (message) {
      this.sendToTolkai(message)
      $input.val('')
      this.syncSubmitState($form)

      if ($input.is('textarea')) {
        this.resizeTextarea($input)
      }
    }
  }

  handleTagClick(e) {
    e.preventDefault()

    const message = $(e.currentTarget).text().trim()

    if (message) {
      this.sendToTolkai(message)
    }
  }

  /**
   * Open the chatbot modal and send a message to the Tolk.ai proxy endpoint.
   *
   * @param {string} message
   */
  sendToTolkai(message) {
    if (this.isRequestPending) {
      return
    }

    this.openChatbotUi()
    this.addMessage('user', message)
    this.setLoading(true)

    const dialogueUrl = window.chatbotConfig && window.chatbotConfig.dialogueUrl

    if (!dialogueUrl) {
      this.setLoading(false)
      this.reportError(new Error('Chatbot dialogue URL is missing'))
      this.addMessage('error', 'Le chatbot est momentanément indisponible.')
      return
    }

    this.isRequestPending = true

    fetch(dialogueUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: message,
        conversationToken: this.conversationToken,
        userId: this.userId,
        language: this.language,
        // Site language: picks the Tolk.ai credentials set in the options of that language.
        lang: window.chatbotConfig.siteLanguage,
        page: window.location.pathname
      })
    })
      .then((response) => {
        if (response.status === 429) {
          throw new Error('rate-limited')
        }

        if (!response.ok) {
          throw new Error(`Chatbot request failed with status ${response.status}`)
        }

        return response.json()
      })
      .then((data) => this.handleDialogueResponse(data))
      .catch((error) => {
        // Le rate limit est notre propre garde-fou, pas une erreur à remonter.
        if (error.message === 'rate-limited') {
          this.addMessage('error', 'Trop de messages envoyés, merci de réessayer dans quelques minutes.')
          return
        }

        this.reportError(error)
        this.addMessage('error', 'Une erreur est survenue, merci de réessayer.')
      })
      .finally(() => {
        this.isRequestPending = false
        this.setLoading(false)
        this.syncConversationState()
      })
  }

  /**
   * Send a chatbot error to Sentry. window.Sentry only exists in prod (see sentry-config.js).
   *
   * @param {Error} error
   */
  reportError(error) {
    // ponytail: an error raised before window.load (SDK not injected yet) is dropped; queue it in SentryConfig if that shows up.
    if (window.Sentry) {
      window.Sentry.captureException(error)
    }
  }

  handleDialogueResponse(data) {
    if (!data || !data.response) {
      this.reportError(new Error('Chatbot response is invalid'))
      this.addMessage('error', 'Réponse invalide du chatbot.')
      return
    }

    if (data.conversationToken) {
      this.setConversationToken(data.conversationToken)
      this.writeToStorage(CONVERSATION_TOKEN_STORAGE_KEY, this.conversationToken)
    }

    const content = data.response.content

    if (data.response.type === 'fallback' || !Array.isArray(content) || !content.length) {
      this.addMessage('bot', 'Désolé, je n\'ai pas compris votre demande.', data.response.id)
      return
    }

    this.renderContentItems('bot', content, data.response.id)
  }

  /**
   * Render the content items of a dialogue turn (live or restored from history).
   * Supports 'text' items (message), 'button' items (optional heading text +
   * quick-reply chips) and 'carousel' items (classic or product cards).
   *
   * @param {string} type 'user' | 'bot'
   * @param {Array} content
   * @param {string} [messageId] Tolk.ai message id, used for feedback tracking
   */
  renderContentItems(type, content, messageId) {
    if (!Array.isArray(content)) {
      return
    }

    // Une réponse du bot peut contenir plusieurs éléments : une seule barre
    // d'actions (copier / like / dislike) est ajoutée après l'ensemble du tour.
    const withActions = type !== 'bot'
    const texts = []

    const addText = (text) => {
      texts.push(text)
      this.addMessage(type, text, messageId, withActions)
    }

    content.forEach((item) => {
      if (!item) {
        return
      }

      if (item.format === 'text' && item.text) {
        addText(item.text)
        return
      }

      if (item.format === 'button') {
        if (item.text) {
          addText(item.text)
        }

        this.renderQuickReplies(item.buttons)
        return
      }

      if (item.format === 'carousel') {
        this.renderCarousel(item)
      }
    })

    if (!withActions && texts.length) {
      const $actions = $('<div></div>', { class: `chatbot-message chatbot-message-${type}` })

      if (messageId) {
        $actions.data('messageId', messageId)
      }

      this.$messages.append($actions.append(this.buildMessageActions(type, this.stripMarkdown(texts.join('\n\n')))))
      this.scrollMessagesToBottom()
    }
  }

  /**
   * Render quick-reply chips for a 'button' content item.
   * - 'choice' / 'custom-answer' / 'static-content': sends a message back (reference if available, else the label).
   * - 'link': opens the URL in a new tab.
   *
   * @param {Array} buttons
   */
  renderQuickReplies(buttons) {
    if (!Array.isArray(buttons) || !buttons.length || !this.$messages.length) {
      return
    }

    const $container = $('<div></div>', { class: 'chatbot-quick-replies' })

    buttons.forEach((button) => {
      if (!button || !button.text) {
        return
      }

      const isLink = button.type === 'link' && button.url
      const $label = $('<span></span>', { text: button.text })
      const $icon = $('<i></i>', { class: `icon ${isLink ? 'icon-arrow-up-right' : 'icon-chatbot-reply'}`, 'aria-hidden': 'true' })

      if (isLink) {
        $container.append($('<a></a>', {
          class: 'chatbot-quick-reply js-chatbot-quick-reply',
          href: button.url,
          target: '_blank',
          rel: 'noopener noreferrer'
        }).append($icon, $label))
        return
      }

      const $button = $('<button></button>', {
        type: 'button',
        class: 'chatbot-quick-reply js-chatbot-quick-reply'
      }).append($icon, $label)

      $button.data('quickReplyMessage', button.reference || button.text)
      $container.append($button)
    })

    if (!$container.children().length) {
      return
    }

    this.$messages.append($container)
    this.scrollMessagesToBottom()
  }

  /**
   * Render a 'carousel' content item as a list card: optional heading (the
   * carousel text) then one row per card (image, title, description, price /
   * availability badge), the whole row linking to the card URL. The buttons of
   * the cards are rendered as quick replies below the list.
   *
   * @param {Object} carousel
   */
  renderCarousel(carousel) {
    const cards = Array.isArray(carousel.cards) ? carousel.cards.filter(Boolean) : []

    if (!cards.length || !this.$messages.length) {
      return
    }

    const $list = $('<div></div>', { class: 'chatbot-list' })

    if (carousel.text) {
      $list.append($('<div></div>', { class: 'chatbot-list-header' }).append(
        $('<i></i>', { class: 'icon icon-chatbot-bag', 'aria-hidden': 'true' }),
        $('<span></span>', { text: carousel.text })
      ))
    }

    const $items = $('<div></div>', { class: 'chatbot-list-items' })
    const buttons = []

    cards.forEach((card) => {
      $items.append(this.buildListItemElement(card))

      if (Array.isArray(card.buttons)) {
        buttons.push(...card.buttons)
      }
    })

    $list.append($items)
    this.$messages.append($('<div></div>', { class: 'chatbot-message-extra' }).append($list))
    this.renderQuickReplies(buttons)
    this.scrollMessagesToBottom()
  }

  buildListItemElement(card) {
    const link = card.link && card.link.url ? card.link : null
    const $item = link
      ? $('<a></a>', { class: 'chatbot-list-item', href: link.url, target: '_blank', rel: 'noopener noreferrer' })
      : $('<div></div>', { class: 'chatbot-list-item' })

    if (card.image) {
      $item.append($('<img>', { class: 'chatbot-list-item-image', src: card.image, alt: '', loading: 'lazy', width: 40, height: 40 }))
    }

    const $body = $('<span></span>', { class: 'chatbot-list-item-body' })

    $body.append($('<span></span>', { class: 'chatbot-list-item-title', text: card.title || (link && link.text) || '' }))

    if (card.description) {
      $body.append($('<span></span>', { class: 'chatbot-list-item-description', text: card.description }))
    }

    const price = card.format === 'product' && card.product ? this.formatPrice(card.product) : ''

    if (price) {
      $body.append($('<span></span>', { class: 'chatbot-list-item-price', text: price }))
    }

    $item.append($body)

    const availability = card.product && card.product.availability

    if (availability && availability.text) {
      $item.append($('<span></span>', {
        class: `chatbot-list-item-badge is-${availability.type || 'available'}`,
        text: availability.text
      }))
    }

    return $item
  }

  formatPrice(product) {
    if (typeof product.price !== 'number') {
      return ''
    }

    const locale = document.documentElement.lang || 'fr'

    try {
      return product.currency
        ? product.price.toLocaleString(locale, { style: 'currency', currency: product.currency })
        : product.price.toLocaleString(locale)
    } catch (err) {
      // Devise inconnue : on garde le prix brut.
      return String(product.price)
    }
  }

  handleQuickReplyClick(e) {
    const message = $(e.currentTarget).data('quickReplyMessage')

    // Les liens (type 'link') n'ont pas de message : on laisse le navigateur les ouvrir.
    if (!message) {
      return
    }

    e.preventDefault()
    this.sendToTolkai(String(message))
  }

  handleCopyClick(e) {
    e.preventDefault()

    const $button = $(e.currentTarget)
    const text = $button.data('copyText') || ''

    this.copyToClipboard(String(text)).then(() => {
      window.clearTimeout($button.data('copiedTimer'))
      $button.addClass('is-copied').attr({ 'aria-label': this.labels.copied, 'data-tooltip': this.labels.copied })

      $button.data('copiedTimer', window.setTimeout(() => {
        $button.removeClass('is-copied').attr({ 'aria-label': this.labels.copy, 'data-tooltip': this.labels.copy })
      }, COPIED_FEEDBACK_DURATION))
    }).catch(() => {
      // Presse-papier indisponible : rien à signaler à l'utilisateur.
    })
  }

  copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      // L'API peut être refusée (iframe, permissions) : on retente alors avec le repli.
      return navigator.clipboard.writeText(text).catch(() => this.copyWithTextarea(text))
    }

    return this.copyWithTextarea(text)
  }

  /**
   * Fallback copy for contexts without (or refusing) the Clipboard API.
   *
   * @param {string} text
   * @return {Promise}
   */
  copyWithTextarea(text) {
    return new Promise((resolve, reject) => {
      const $textarea = $('<textarea></textarea>', { class: 'chatbot-clipboard', readonly: true }).val(text)

      $('body').append($textarea)
      $textarea.get(0).select()

      const isCopied = document.execCommand('copy')
      $textarea.remove()

      if (isCopied) {
        resolve()
        return
      }

      reject(new Error('Copy failed'))
    })
  }

  /**
   * Like / dislike a bot answer. Tolk.ai does not expose a feedback endpoint,
   * so the vote is only reflected in the UI and pushed to GTM (dataLayer).
   */
  handleFeedbackClick(e) {
    e.preventDefault()

    const $button = $(e.currentTarget)
    const isActive = !$button.hasClass('is-active')
    const value = $button.data('feedback')

    $button.siblings('.js-chatbot-feedback').removeClass('is-active').attr('aria-pressed', 'false')
    $button.toggleClass('is-active', isActive).attr('aria-pressed', isActive ? 'true' : 'false')

    if (!isActive) {
      return
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'chatbot_feedback',
      chatbot_feedback: value,
      chatbot_conversation_id: this.conversationId,
      chatbot_message_id: $button.closest('.chatbot-message').data('messageId') || ''
    })
  }

  /**
   * Restore the previous conversation (if any) so it survives a page reload,
   * by fetching it back from Tolk.ai via the history proxy endpoint.
   */
  loadHistory() {
    const historyUrl = window.chatbotConfig && window.chatbotConfig.historyUrl

    if (!historyUrl || !this.conversationToken || !this.$messages.length) {
      return
    }

    const conversationToken = this.conversationToken
    const url = `${historyUrl}?conversationToken=${encodeURIComponent(conversationToken)}&lang=${encodeURIComponent(window.chatbotConfig.siteLanguage)}`

    fetch(url)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        // Conversation réinitialisée (ou déjà relancée) pendant le chargement : on ignore l'historique.
        if (!data || !Array.isArray(data.history) || conversationToken !== this.conversationToken || this.$messages.children().not(this.$loader).length) {
          return
        }

        data.history.forEach((entry) => {
          const type = entry.trigger && entry.trigger.resource === 'ai' ? 'bot' : 'user'

          this.renderContentItems(type, entry.content, entry.id)
        })
      })
      .catch(() => {
        // Historique indisponible : on repart simplement d'une conversation vide.
      })
  }

  setLoading(isLoading) {
    this.$loader.toggleClass('is-visible', isLoading).attr('aria-hidden', isLoading ? 'false' : 'true')
    this.stopThinkingMessages()

    if (isLoading) {
      // L'indicateur « Réflexion… » se place juste sous le dernier message.
      this.$messages.append(this.$loader)
      this.scrollMessagesToBottom()
      this.startThinkingMessages()
    }
  }

  /**
   * Show the thinking messages in turn (sorted by delay server-side);
   * the last one stays displayed until the answer arrives.
   */
  startThinkingMessages() {
    this.thinkingMessages.forEach((thinkingMessage, index) => {
      if (index === 0) {
        this.$loaderLabel.text(thinkingMessage.text)
        return
      }

      this.thinkingTimers.push(setTimeout(() => {
        this.$loaderLabel.addClass('is-changing')

        this.thinkingTimers.push(setTimeout(() => {
          this.$loaderLabel.text(thinkingMessage.text).removeClass('is-changing')
        }, THINKING_FADE_DURATION))
      }, thinkingMessage.delay * 1000))
    })
  }

  stopThinkingMessages() {
    this.thinkingTimers.forEach((timer) => clearTimeout(timer))
    this.thinkingTimers = []
    this.$loaderLabel.removeClass('is-changing')
  }

  addMessage(type, text, messageId, withActions = true) {
    if (!this.$messages.length || !text) {
      return
    }

    this.$messages.append(this.buildMessageElement(type, text, messageId, withActions))
    this.syncConversationState()
    this.scrollMessagesToBottom()
  }

  buildMessageElement(type, text, messageId, withActions = true) {
    const $message = $('<div></div>', { class: `chatbot-message chatbot-message-${type}` })
    const $bubble = $('<div></div>', { class: 'chatbot-message-bubble' })

    if (messageId) {
      $message.data('messageId', messageId)
    }

    if (type === 'bot') {
      $bubble.html(this.formatMessageText(text))
    } else {
      $bubble.text(text)
    }

    $message.append($bubble)

    if (withActions && type !== 'error') {
      $message.append(this.buildMessageActions(type, type === 'bot' ? this.stripMarkdown(text) : text))
    }

    return $message
  }

  buildMessageActions(type, text) {
    const $actions = $('<div></div>', { class: 'chatbot-message-actions' })

    const $copy = this.buildActionButton('js-chatbot-copy', 'icon-chatbot-copy', this.labels.copy)
    $copy.data('copyText', text)
    $actions.append($copy)

    if (type !== 'bot') {
      return $actions
    }

    const feedbacks = ['like', 'dislike']

    feedbacks.forEach((feedback) => {
      $actions.append($('<span></span>', { class: 'chatbot-message-actions-divider', 'aria-hidden': 'true' }))

      const $feedback = this.buildActionButton('js-chatbot-feedback', `icon-chatbot-${feedback}`, this.labels[feedback])

      $feedback.attr('aria-pressed', 'false').data('feedback', feedback)
      $actions.append($feedback)
    })

    return $actions
  }

  buildActionButton(jsClass, icon, label) {
    return $('<button></button>', {
      type: 'button',
      class: `chatbot-message-action ${jsClass}`,
      'aria-label': label,
      'data-tooltip': label
    }).append($('<i></i>', { class: `icon ${icon}` }))
  }

  scrollMessagesToBottom() {
    this.$messages.scrollTop(this.$messages.prop('scrollHeight'))
  }

  /**
   * Turn the raw Tolk.ai text (light Markdown: paragraphs separated by blank
   * lines, "- " bullet lists, **bold**, [label](url) links, plain URLs) into
   * safe, readable HTML.
   *
   * @param {string} text
   * @return {string}
   */
  formatMessageText(text) {
    const html = []
    let listItems = []

    const flushList = () => {
      if (listItems.length) {
        html.push(`<ul>${listItems.map((item) => `<li>${item}</li>`).join('')}</ul>`)
        listItems = []
      }
    }

    text.split(/\n{2,}/).forEach((block) => {
      const lines = block.split('\n').map((line) => line.trim()).filter(Boolean)

      if (!lines.length) {
        return
      }

      // Un bloc qui commence par "- " ou "* " est un élément de liste ; les lignes
      // suivantes sans puce en sont la continuation. Les blocs de liste consécutifs
      // (séparés par une ligne vide) sont regroupés dans la même <ul>.
      if (/^[-*] /.test(lines[0])) {
        lines.forEach((line) => {
          if (/^[-*] /.test(line)) {
            listItems.push(this.formatInlineText(line.slice(2)))
            return
          }

          listItems[listItems.length - 1] += `<br>${this.formatInlineText(line)}`
        })
        return
      }

      flushList()
      html.push(`<p>${lines.map((line) => this.formatInlineText(line)).join('<br>')}</p>`)
    })

    flushList()

    return html.join('')
  }

  /**
   * Format one line of text: escape HTML, then render **bold**, [label](url)
   * links and plain URLs.
   *
   * @param {string} text
   * @return {string}
   */
  formatInlineText(text) {
    const escapeHtml = (str) => str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')

    const formatBold = (str) => escapeHtml(str).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')

    const buildLink = (url, label) => `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${label}</a>`

    const linkPattern = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<]+)/g
    let html = ''
    let lastIndex = 0
    let match

    while ((match = linkPattern.exec(text)) !== null) {
      html += formatBold(text.slice(lastIndex, match.index))

      if (match[1]) {
        html += buildLink(match[2], formatBold(match[1]))
      } else {
        // On détache la ponctuation finale (. , ; :) pour ne pas l'inclure dans le lien.
        const cleanUrl = match[3].replace(/[.,;:)]+$/, '')

        html += buildLink(cleanUrl, escapeHtml(cleanUrl)) + escapeHtml(match[3].slice(cleanUrl.length))
      }

      lastIndex = linkPattern.lastIndex
    }

    return html + formatBold(text.slice(lastIndex))
  }

  /**
   * Plain-text version of a Tolk.ai answer, used by the copy button.
   *
   * @param {string} text
   * @return {string}
   */
  stripMarkdown(text) {
    return text
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '$1 ($2)')
      .replace(/\*\*(.+?)\*\*/g, '$1')
      .replace(/[ \t]+\n/g, '\n')
  }
}
